import { SegmentSchema } from '@sondermind/segment';

export interface IAccountCompleteData {
  submitted_at: string;
}

export enum CurrentUserSegmentEvents {
  ACCOUNT_COMPLETED = 'Account Completed'
}

export interface ICurrentUserSegmentSchema extends SegmentSchema {
  [CurrentUserSegmentEvents.ACCOUNT_COMPLETED]: IAccountCompleteData;
}
